import z from 'zod';

export const peopleTypeaheadValueSchema = z.object({
  href: z.string(),
  title: z.string(),
  type: z.union([z.literal('link'), z.literal('query')]),
});

export type PeopleTypeaheadValue = z.infer<typeof peopleTypeaheadValueSchema>;
